$(document).ready(function() {
    const searchForm = $('.amsearch-form-block');

    $('.search-toggle').on('click', function(e) {
        searchForm.toggleClass('visible');

        if (searchForm.hasClass('visible')) {
            searchForm.find('input').focus();
        }
    });
});
